import React, { useContext } from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";
import { GridColumn, GridRow, Label } from "notes";
import { Field, TimeContext, EventContext } from "Components";
import { fonts } from "../../../../../../theme/fonts";

export const FormFields = ({
  formData,
  formPart,
  handleChange,
  errors,
  registration,
  ...props
}) => {
  const { body, heading, subHeading, fields, formHeading } = formData;
  const { time } = useContext(TimeContext);
  const { event } = useContext(EventContext);

  return (
    <>
      {formPart === 1 ? (
        time < formData.endSweeps ? (
          // content to show before end of sweepstakes
          <>
            {heading && <Heading>{ReactHtmlParser(heading)}</Heading>}
            {subHeading && <SubHeading>{subHeading}</SubHeading>}
            {body && <Body>{ReactHtmlParser(body)}</Body>}
            {formHeading && <FormTitle>{formHeading}</FormTitle>}
          </>
        ) : (
          // content after sweepstakes
          <>
            {heading && <Heading>{ReactHtmlParser(heading)}</Heading>}
            <SubHeading>
              Register for your free ticket to see {event.artist}’s exclusive
              one-night livestream performance!
            </SubHeading>
          </>
        )
      ) : time < formData.endSweeps ? (
        // before end of sweepstakes
        <>
          <Heading>
            You’re now registered for the show! Please check your email for your
            free ticket.
          </Heading>
          <SubHeading>
            Complete the questions below to be entered for a chance to win a
            virtual meet & greet with {event.artist}!
          </SubHeading>
        </>
      ) : (
        // after sweepstakes ends
        <>
          {heading && <Heading>{ReactHtmlParser(heading)}</Heading>}
          <SubHeading>
            Complete the questions below to be registered for the show. Please
            check your email for your free ticket!
          </SubHeading>
        </>
      )}

      <Form>
        {fields &&
          fields
            .sort((a, b) => a.order - b.order)
            .filter((field) => {
              if (formPart === 1) {
                return !field.formPart;
              } else if (formPart === 2) {
                return field.formPart === 2;
              }
              return field;
            })
            .map((field, index) => {
              return (
                <FieldContainer fullSize={field.span === "full"} key={index}>
                  {field.type !== "optIn" && !!field.label && (
                    <Label>{field.label}</Label>
                  )}
                  <Field
                    field={field}
                    fieldCheck={
                      !!field.requires ? registration[field.requires] : true
                    }
                    value={registration[field.name]}
                    onChange={(value) => handleChange(value, field.name)}
                    error={{
                      status: errors[field.name],
                      message: "This is a required field and cannot be blank.",
                    }}
                  />
                </FieldContainer>
              );
            })}
      </Form>

      {formPart === 1 && time < formData.endSweeps && (
        <p>
          <SweepstakesRulesLink
            href="https://fordmusic.com/raelynn-truck-month-rules"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sweepstakes Rules
          </SweepstakesRulesLink>
        </p>
      )}

      {formPart === 2 && (
        <RegistrationDisclaimer>
          By providing your information, you are directing Music Audience
          Exchange to share your name, email address, and zip code with Ford for
          use as described in{" "}
          <a
            href="https://www.ford.com/help/privacy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ford’s Privacy Policy
          </a>
          . The collection and use of any information collected is otherwise
          subject to{" "}
          <a
            href="https://musicaudienceexchange.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Music Audience Exchange’s Privacy Policy
          </a>
          .
        </RegistrationDisclaimer>
      )}
    </>
  );
};

const SweepstakesRulesLink = styled.a`
  font-size: 12px;
  color: #626466;
  text-transform: uppercase;
`;

const RegistrationDisclaimer = styled.p`
  font-size: 12px;
  color: #626466;

  a {
    color: #626466;
  }
`;

const Heading = styled.h2`
  font-family: ${fonts.brand.bold};
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 16px;
  text-transform: uppercase;
  color: #4580dd;
`;

const SubHeading = styled.h3`
  font-family: ${fonts.brand.medium};
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 8px;
`;

const Body = styled.p`
  font-family: ${fonts.brand.regular};
  order: 3;
`;

const FormTitle = styled.h3`
  color: #ffffff;
  order: 4;
`;

const Form = styled(GridRow)`
  align-items: flex-start;
  flex-wrap: wrap;
  margin-left: -4px;
  margin-right: -4px;
  order: 5;
`;

const FieldContainer = styled(GridColumn)`
  flex: 0 1 ${(props) => (props.fullSize ? "100%" : "50%")};
  padding: 8px 4px 0 4px;
  width: ${(props) => (props.fullSize ? "100%" : "50%")};
`;
